import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';

//import { BsDatepickerModule } from 'ngx-bootstrap';

//import { TSCalendarComponent } from '../common/tscalendar/tscalendar';

//import { ChipsModule, InputTextModule } from '../../lib/primeng/primeng';
import { StatComponent } from './stat.main';

@NgModule({
    declarations: [
        StatComponent,
        // AddressComponent,
        //      TSCalendarComponent
    ],
    imports: [
        BrowserModule,
        //    ChipsModule,
        // InputTextModule,
        FormsModule,
        HttpModule,
        //  BsDatepickerModule.forRoot()
    ],
    providers: [SiteServices],
    bootstrap: [StatComponent],
})
export class StatModule {}
